import { render, staticRenderFns } from "./dish-form.vue?vue&type=template&id=55f9fb76&scoped=true"
import script from "./dish-form.vue?vue&type=script&lang=js"
export * from "./dish-form.vue?vue&type=script&lang=js"
import style0 from "./dish-form.vue?vue&type=style&index=0&id=55f9fb76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f9fb76",
  null
  
)

export default component.exports